<template>
  <div class="download main-bg">
    <!-- <div class="download-bg"></div> -->
    <div class="download-content">
      <div>
        <img src="@/assets/img/download-icon.png" class="download-icon" />
      </div>
      <div class="download-right">
        <p class="main-cl download-title">{{ $t('homeTemplate.text_17') }}</p>
        <p class="gray-cl download-text">{{ $t('homeTemplate.text_24') }}</p>
        <div v-if="from === 'homes'" class="download-home-buttons">
          <c-button
            width="160px"
            height="48px"
            paddingW="0"
            class="download-button mr-16"
            defaultColorClass="black-bg white-cl"
            hoverColorClass="blue-bg white-cl"
            activeColorClass="blue-bg white-cl"
            v-for="(item, index) in homeChannelList"
            :key="index"
            @click="channelDownload(item.id)">
            <svg-icon :iconClass="`icon_${item.name.replace(/\s*/g, '')}`" className="icon-24 download-btn-icon"></svg-icon>
            <span>{{ item.name }}</span>
          </c-button>
          <!-- App Store app_store_url -->
          <!-- <c-button
            width="160px"
            height="48px"
            paddingW="0"
            class="download-button mr-16"
            defaultColorClass="black-bg white-cl"
            hoverColorClass="blue-bg white-cl"
            activeColorClass="blue-bg white-cl"
            @click="download('ios')">
            <svg-icon iconClass="apple" className="icon-24 download-btn-icon"></svg-icon>
            <span>{{ $t('appDownLoad.download_text_1') }}</span>
          </c-button> -->
          <!-- Google Play google_play_url -->
          <!-- <c-button
            width="160px"
            height="48px"
            paddingW="0"
            class="download-button mr-16"
            defaultColorClass="black-bg white-cl"
            hoverColorClass="blue-bg white-cl"
            activeColorClass="blue-bg white-cl"
            @click="linkGooglePlay">
            <svg-icon iconClass="google" className="icon-24 download-btn-icon"></svg-icon>
            <span>{{ $t('appDownLoad.download_text_4') }}</span>
          </c-button> -->
          <!-- Android APK android_download_url -->
          <!-- <c-button
            width="160px"
            height="48px"
            paddingW="0"
            class="download-button mr-16"
            defaultColorClass="black-bg white-cl"
            hoverColorClass="blue-bg white-cl"
            activeColorClass="blue-bg white-cl"
            @click="download('android')">
            <svg-icon iconClass="android" className="icon-24 download-btn-icon"></svg-icon>
            <span>{{ $t('appDownLoad.download_text_2') }}</span>
          </c-button> -->
          <div class="download-home-icon black-bg white-cl"
            @mouseenter="isCodeHover = true"
            @mouseleave="isCodeHover = false"
            :class="{'blue-bg': isCodeHover}">
            <a-tooltip
              placement="bottom"
              :arrowPointAtCenter="true">
              <svg-icon iconClass="qrcode" className="icon-24" style="padding: 12px;"></svg-icon>
              <template slot="title">
                <div class="download-home-content">
                  <!-- <img class="download-home-code" src="@/assets/img/qrCode.png" /> -->
                  <c-download-qrcode></c-download-qrcode>
                  <p class="download-home-text">{{ $t("appDownLoad.headerCode") }}</p>
                </div>
              </template>
            </a-tooltip>
          </div>
        </div>
        <div class="download-info" v-else>
          <!-- android_download_url -->
          <!-- <div ref="qrcode" class="download-code"></div> -->
          <c-download-qrcode style="width: 160px;height: 160px;padding:0;margin-bottom: 24px;"></c-download-qrcode>
          <div :class="channelList.length < 4 ? 'download-buttons' : 'download-buttons-many'">
            <c-button
              width="160px"
              height="48px"
              paddingW="0"
              class="download-button mb-24"
              v-for="(item, index) in channelList"
              :key="index"
              @click="channelDownload(item.id)">
              <svg-icon :iconClass="`icon_${item.name.replace(/\s*/g, '')}`" className="icon-24 download-btn-icon"></svg-icon>
              <span>{{ item.name }}</span>
            </c-button>
            <!-- TestFlight ios_ipa_download_url -->
            <!-- <c-button
              width="160px"
              height="48px"
              paddingW="0"
              class="download-button mr-16 mb-24"
              @click="download('ios_ipa')">
              <svg-icon iconClass="testFlight" className="icon-24 download-btn-icon"></svg-icon>
              <span>{{ $t('appDownLoad.download_text_3') }}</span>
            </c-button> -->
            <!-- Android APK android_download_url -->
            <!-- <c-button
              width="160px"
              height="48px"
              paddingW="0"
              class="download-button mb-24"
              @click="download('android')">
              <svg-icon iconClass="android" className="icon-24 download-btn-icon"></svg-icon>
              <span>{{ $t('appDownLoad.download_text_2') }}</span>
            </c-button> -->
            <!-- App Store app_store_url -->
            <!-- <c-button
              width="160px"
              height="48px"
              paddingW="0"
              class="download-button mr-16"
              @click="download('ios')">
              <svg-icon iconClass="apple" className="icon-24 download-btn-icon"></svg-icon>
              <span>{{ $t('appDownLoad.download_text_1') }}</span>
            </c-button> -->
            <!-- Google Play google_play_url -->
            <!-- <c-button
              width="160px"
              height="48px"
              paddingW="0"
              class="download-button"
              @click="linkGooglePlay">
              <svg-icon iconClass="google" className="icon-24 download-btn-icon"></svg-icon>
              <span>{{ $t('appDownLoad.download_text_4') }}</span>
            </c-button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imgMap } from '@/utils';

const QRCode = window.QRCode;

export default {
  name: 'appDownload',
  data() {
    return {
      resource: '',
      isCodeHover: false,
      channelList: [],
      homeChannelList: [],
    };
  },
  props: {
    from: {
      type: String,
      default: '',
    },
  },
  watch: {
    appDownload(v) {
      if (v) {
        this.getchannelId();
      }
    },
    $route: {
      handler(n) {
        this.resource = n.name === 'install' ? 'apple' : 'android';
      },
      immediate: true,
    },
  },
  computed: {
    navList() {
      return [
        {
          url: this.imgs.download_flag_1,
          title: this.$t('appDownLoad.flag')[0].title,
          desc: this.$t('appDownLoad.flag')[0].desc,
        },
        {
          url: this.imgs.download_flag_2,
          title: this.$t('appDownLoad.flag')[1].title,
          desc: this.$t('appDownLoad.flag')[1].desc,
        },
        {
          url: this.imgs.download_flag_3,
          title: this.$t('appDownLoad.flag')[2].title,
          desc: this.$t('appDownLoad.flag')[2].desc,
        },
        {
          url: this.imgs.download_flag_4,
          title: this.$t('appDownLoad.flag')[3].title,
          desc: this.$t('appDownLoad.flag')[3].desc,
        },
      ];
    },
    appDownload() {
      return this.$store.state.baseData.app_download;
    },
    mainBg() {
      return `background-image: url("${imgMap.appdownload_bg}#0E1A2E")`;
    },
    imgs() {
      return imgMap;
    },
  },
  mounted() {
    console.log('dfjskfjkds')
    this.init();
  },
  methods: {
    linkAppstore() {
      const url = this.appDownload.app_store_url;
      window.open(url);
    },
    linkGooglePlay() {
      const url = this.appDownload.google_play_url;
      window.open(url);
    },
    download(type) {
      window.open(this.appDownload[`${type}_download_url`]);
    },
    init() {
      if (this.from === 'homes') {
        this.getHomeChannelList();
      } else {
        this.getChannelList();
      }
      this.getchannelId();
    },
    getchannelId() {
      if (!this.appDownload) {
        return;
      }

      if (this.$refs.qrcode) {
        const qrcode = new QRCode(this.$refs.qrcode, {
          width: 140,
          height: 140,
        });

        const url = this.appDownload.download_serve_url;
        qrcode.makeCode(url);
      }
    },
    // 获取渠道列表
    getChannelList() {
      this.axios({
        url: 'channel/list',
        method: 'get',
      }).then((res) => {
        if (!Number(res.code)) {
          this.channelList = res.data.list
        } else {
          this.$bus.$emit('tip', {
            text: res.message,
            type: 'error',
          });
        }
      })
    },
    // 获取渠道下载地址
    channelDownload(id) {
      this.axios({
        url: 'channel/download?id='+id,
        method: 'get',
      }).then((res) => {
        if (!Number(res.code)) {
          window.open(res.data);
        } else {
          this.$bus.$emit('tip', {
            text: res.message,
            type: 'error',
          });
        }
      })
    },
    // 获取首页下载列表 
    getHomeChannelList() {
      this.axios({
        url: 'channel/type/list',
        method: 'get',
      }).then((res) => {
        if (!Number(res.code)) {
          if (res.data[0] && res.data[0].type === 'ios') {
            this.homeChannelList = res.data
          } else {
            this.homeChannelList = res.data.reverse()
          }
        } else {
          this.$bus.$emit('tip', {
            text: res.message,
            type: 'error',
          });
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '@/assets/css/global.scss';

  .light {
    .download-code  {
      background-color: $dark-bg;
    }
  }

  .download {
    width: 100%;
    // height: 656px;
    min-height: calc(100vh - 165px);
    position: relative;
    .download-bg {
      width: 100%;
      height: 390px;
      background: url('~@/assets/img/download-bg.png') no-repeat;
      background-size: 100% 390px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .download-content {
      padding: 80px 0 30px;
      box-sizing: border-box;
      max-width: 1200px;
      margin: 0 auto;
      z-index: 2;
      position: relative;
    }
    .download-content, .download-info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 32px;
    }
    .download-icon {
      width: 546px;
      height: 546px;
    }
    .download-right {
      margin-left: 104px;
      font-family: 'Medium';
    }
    .download-title {
      font-size: 36px;
      line-height: 58px;
      font-weight: 600;
    }
    .download-text {
      font-size: 20px;
      line-height: 32px;
      margin: 5px 0 40px;
    }
    .download-code {
      width: 140px;
      min-width: 140px;
      height: 140px;
      padding: 10px;
      background-color: $white;
      border-radius: 4px;
    }
    .download-buttons {
      width: 180px;
    }
    .download-buttons-many {
      width: 340px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .download-button {
      font-size: 16px;
      line-height: 48px;
      ::v-deep .common-button-slot {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .mr-16 {
      margin-right: 16px;
    }
    .mb-24 {
      margin-bottom: 24px;
    }
    .download-btn-icon {
      vertical-align: text-bottom;
      margin-right: 8px;
    }
    .download-home-buttons {
      display: flex;
      .download-home-icon {
        width: 48px;
        height: 48px;
        border-radius: 4px;
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .download-home-content {
    padding: 15px 15px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Medium';
    .download-home-code {
      width: 140px;
      height: 140px;
    }
    .download-home-text {
      font-size: 14px;
      line-height: 22px;
      margin-top: 8px;
    }
  }
</style>
<!-- <style lang="scss" scoped>
.download-container{
  min-height: 1178px;
  background-size: 100% 570px;
  background-repeat: no-repeat;
  margin-top: -60px;
  .download-options {
    padding-top: 100px;
    padding-bottom: 40px;
    height:460px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
  .download_item_top{
    height:69px;
  }

  .download_main{
    margin: 164px auto;
    display: flex;
    justify-content: center;
  }
  .qrcode{
    background: #fff;
    border-radius: 8px;
    width: 168px;
    height: 168px;
    margin:15px auto;

  }
  #qrcode,#qrcode_android{
    margin:0px auto;
    padding: 5px;
    width: 158px;
    height: 158px;
    }

  .download_img_box{
    width: 202px;
    height: 202px;
    margin-right: 99px;
  }
  .download_img_box img{
    width: 100%;
  }
  .download_btns_box{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .download_btn{
    background: #009BF1;
    border-radius: 5px;
    padding: 10px 23px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
  }
  .download_btn>img{
      width: 44px;
      padding-right: 13px;
      float: left;
  }
  .download_btn:first-child p{
    font-size: 22px;
    letter-spacing: 0;
  }
  .download_btn p{
    letter-spacing: -1px;
    font-size: 18px;
    color: #fff;
    line-height: 32px;
    font-weight: 600;
  }
  .download_btn span{
    font-size: 13px;
    color: #fff;
    line-height: 18px;
  }
  .btn_dec{
    float:left;
    }
  .btn_dec img{
    width: 10px;
    position:relative;
    top: 0px;
    left: 25px;
  }
  .zh.apple .download_btn:last-child .btn_dec p{
    letter-spacing: 1px;
    font-size: 19px;
  }
  .en .download_btn:last-child .btn_dec p{
    letter-spacing: 0px;

  }
  .en.android .btn_dec img{
    width: 16px;
    top: 2px;
    left: 5px;
  }
  .en .download_btn .btn_dec p{
    color:#F4F3F3;
    font-size: 12px;
    line-height: normal;
    padding-top: 7px;
    }
    .en .download_btn .btn_dec span{
    color:#F4F3F3;
    font-size: 14px;
    font-weight: 600;
    }
  .btn_dec img.apple_btn{
    width:20px;
    left: 15px;
    top: 1px;
  }
  .download-step-qr{
    width: 150px;
    height:150px;
    margin-top: 20px;
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box
  }

  .download-options-logo {
    text-align: center;
    img {
      height: 74px;
      width: 74px;
      // display: block;
    }
  }
  .download-options-name {
    text-align: center;
    margin-top: 20px;
    font-size: 32px;
  }
  .download-options-text {
    font-size: 16px;
    text-align: center;
    line-height: 32px;
    margin-top: 6px;
  }
  .download-options-buttons {
    text-align: center;
    margin-top: 35px;
  }
  .download-button {
    margin: 0 10px;
    width: 160px;
  }
  .download-options-rq {
    text-align: center;
    margin: 46px auto 0;
    width: 86px;
    height: 86px;
    background-color: #fff;
    padding: 15px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .download-options-reText {
    font-size: 14px;
    text-align: center;
    line-height: 14px;
    margin-top: 13px;
  }
  .download-nav {
    padding: 80px 0;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    .download-nav-list {
      width: 1034px;
      margin: 0 auto;
    }
    .download-nav-even {
      float: left;
    }
    .download-nav-even:nth-child(even){
      margin-left: 190px;
    }
    .download-nav-even:nth-child(3){
      clear:left;
    }
    .download-nav-even:nth-child(4){
      clear:right;
    }
    .download-nav-even:nth-child(3),
    .download-nav-even:nth-child(4) {
      margin-top: 68px
    }
    .download-nav-img {
      float: left;
    }
    .download-nav-mode {
      float: left;
      margin-left: 36px;
    }
    .download-nav-title {
      font-size: 16px;
      max-width: 326px;
      word-wrap: break-word;
    }
    .download-nav-text {
      margin-top: 14px;
      font-size: 14px;
      max-width: 303px;
      word-wrap: break-word;
      line-height: 22px;
    }
  }
  .download-step {
    padding-top: 54px;
    padding-bottom: 80px;
    .download-step-t {
      line-height: 22px;
      font-size: 14px;
      margin-top: 8px;
    }
    .download-step-title {
      text-align: center;
      font-size: 24px;
      line-height: 32px;
    }
    .download-step-list {
      width: 1034px;
      margin: 0 auto;
      margin-top: 52px;
    }
    .download-step-even {
      height: 360px;
      margin-bottom: 42px;
    }
    .download-step-label {
      float: left;
      font-size: 36px;
      letter-spacing: 0;
      line-height: 48px;
      height: 360px;
      border-right-width: 1px;
      border-right-style: solid;
      padding-right: 12px;
    }
    .download-step-mode {
      float: left;
      margin-left: 26px;
      word-wrap: break-word;
      max-width: 500px;
    }
    .download-step-h {
      font-size: 16px;
      line-height: 32px;
    }
    .download-step-img {
      // width: 320px;
      height: 100%;
      float: right;
      text-align: center;
      img {
        height: 100%;
        // max-width: 320px;
      }
    }
  }
}

  .download_img_box{
    background: url('../assets/images/1/qrcode_bg.png') no-repeat;
    background-size: 100% 100%;
  }
</style> -->
